/*
 * Copyright (c) 2025 curryfirm.com
 */

import { CAPACITIES, SWAPPABLE_CAN_TYPES } from "../../constants.js";

/**
 * Returns the swap type for a given dumpster.
 * @param {import('../../typedefs.js').Dumpster} dumpster - The can to inspect
 * @returns {import(../../constants.js').SWAPPABLE_CAN_TYPES} - One of the defined swappable can type strings
 */
export const getSwapType = (dumpster) => {
    switch (dumpster.capacity) {
        case CAPACITIES.ELEVEN:
            return SWAPPABLE_CAN_TYPES.ELEVENS;
        case CAPACITIES.FIFTEEN:
            return SWAPPABLE_CAN_TYPES.FIFTEENS;
        case CAPACITIES.TWENTYONE:
            return SWAPPABLE_CAN_TYPES.TWENTYONES;
        default:
            throw new Error("Unknown dumpster capacity");
    }
}

/**
 * Return whether the given SwapGroup object has 1 or more cans to haul
 * @param {import('../../typedefs.js').SwapGroup} swapGroup - The swap group to inspect
 * @returns {boolean} true if the swap group has a non-zero-length list of cans to haul; false otherwise
 */
export const hasCanToHaul = (swapGroup) => swapGroup && swapGroup.toHaul && (swapGroup.toHaul.length > 0);